import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Modal, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SimpleReactValidator from 'simple-react-validator';
import { fetchExpoAction } from '../../../redux/action/expo/createAction';
import { fetchPanorama } from '../../../redux/action/expo/panorama';
import { fetchSaloons } from '../../../redux/action/saloons/saloons';
import default_image_url from '../../../redux/api/API';

const ExpoManage = (props) => {
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [deleteAction, setDeleteAction] = useState(false)
    const [actionId, setActionId] = useState('')
    const {t} = useTranslation();

    const [data, setData] = useState({})
    const dispatch = useDispatch()
    const panorama = useSelector(state => state.panorama)
    const saloons = useSelector(state => state.saloons)
    const [type, setType] = useState('')
    const [typeId, setTypeId] = useState([])
    const [action, setAction] = useState({
        title: '',
        type_id: "",
        x_axis: "",
        y_axis: "",
    })

    const handleClose = () => { 
        setDeleteAction(false) 
    }

    const handleDelete = (id) => {
        setDeleteAction(true)
        setActionId(id)
    }

    const changeHandler = event => {
        setAction({ ...action, [event.target.name]: event.target.value })
    }

    const changeTypeHandler = (e) => {
        setType(e.target.value)

        if(e.target.value === 'saloon') {
            setTypeId(saloons.saloons)
        } else {
            setTypeId(panorama.panorama)
        }
    }

    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    useEffect(() => {
        dispatch(fetchSaloons())
    }, [])


    useEffect(() => {
        setData(panorama.panorama.filter(panorama => panorama.id === props.id)[0]);
    }, [panorama.panorama])

    const CreateAction = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        const newAction = {
            panorama_id: props.id,
            title: action.title ,
            type: type,
            type_id: action.type_id ,
            x_axis: action.x_axis ,
            y_axis: action.y_axis 
        }
        if (validator.current.allValid()) {
            dispatch(fetchSaloons())
            setBtnLoading(false)
            dispatch(fetchExpoAction(newAction))
            setAction({
                title: '',
                type_id: "",
                x_axis: "",
                y_axis: "",
            })
            setType()
            window.scrollTo(0,0)
            props.update()
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }

    }

    const deleteThisAction = () => {
        axios.delete(`admin/panorama-action/${actionId}`)
          .then (res => {
            if(res.data) {
                if(res.data.success === true) {
                    toast.dismiss()
                    toast.success(t("toast_successfully_removed") , {position: 'bottom-right',className: 'foo-bar'})
                    setDeleteAction(false) 
                    setTimeout(function(){dispatch(fetchPanorama())}, 500)
                    window.scrollTo(0,0)
                    props.update()
                }
            }
        })
        .catch(err => console.log(err))
    }


  return (
    <div className='mt-4'>
        <div className='d-flex justify-content-end mb-3'>
            <button className='btn btn-primary btn-sm px-5' onClick={() => props.close()}> {t("return")} </button>
        </div>
        <div className='col-lg-6 offset-lg-3 d-flex justify-content-center'>
            <img src={default_image_url+data.path} style={{maxWidth: '100%'}} />
        </div>
        {data.actions && data.actions.length ?
            <div className='col-lg-12 mt-5 mb-3'>
                <Table bordered responsive>
                    <thead>
                        <tr>
                            <th>{t("explanations")}</th>
                            <th>{t("type")}</th>
                            <th>{t("Horizontal position")}</th>
                            <th>{t("Vertical position")}</th>
                            <th className='text-center'>{t("delete")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.actions.map(action => (
                            <tr key={action.id}>
                                <td>{action.title}</td>
                                <td>{action.type === 'saloon' ? t("hall") : t("panorama")}</td>
                                <td>{action.x_axis}</td>
                                <td>{action.y_axis}</td>
                                <td className='text-center'><button className='btn btn-danger btn-sm px-3' onClick={id => handleDelete(action.id)}>{t("delete")}</button></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        :
            ''
        }
        
        <h5 className='text-center mt-5 mb-3'>ایجاد اکشن:</h5>
        <Form className='col-lg-6' onSubmit={CreateAction}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>توضیح: </Form.Label>
                <Form.Control type="text" name="title" value={action.title} onChange={changeHandler} />
                <span className='validator_error'>{validator.current.message('title', action.title, 'required')}</span>
            </Form.Group>

            <Form.Group className="mb-3" controlId="actionType">
                <Form.Label>نوع اکشن:</Form.Label>
                <Form.Select name="type" value={type} onChange={changeTypeHandler} >
                    <option hidden>نوع</option>
                    <option value="saloon">سالن</option>
                    <option value="panorama">پانوراما</option>
                </Form.Select>
                <span className='validator_error'>{validator.current.message('type', type, 'required')}</span>
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label>انتخاب نوع:</Form.Label>
                <Form.Select name="type_id" value={action.type_id} onChange={changeHandler}>
                    <option>نوع</option>
                    {type === 'saloon' ?
                        typeId.map(item => (
                            <option key={item.id} id={item.id} value={item.id}>{item.name}</option>
                        ))
                    :
                        typeId.map(item => (
                            <option key={item.id} id={item.id} value={item.id}>{item.title}</option>
                        ))
                    }
                </Form.Select>
                <span className='validator_error'>{validator.current.message('type_id', action.type_id, 'required')}</span>
            </Form.Group>

            <Row>
                <Col>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>موقعیت افقی:</Form.Label>
                        <Form.Control type="number" name="x_axis" value={action.x_axis} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('x_axis', action.x_axis, 'required')}</span>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>موقعیت عمودی:</Form.Label>
                        <Form.Control type="number" name="y_axis" value={action.y_axis} onChange={changeHandler} />
                        <span className='validator_error'>{validator.current.message('y_axis', action.y_axis, 'required')}</span>
                    </Form.Group>
                </Col>
            </Row>
            <div className='d-flex justify-content-end'>
                <button className='btn btn-success px-3' disabled={btnLoading ? true : false}>ثبت</button>
            </div>
        </Form>
            {deleteAction ? 
                <Modal show={deleteAction} onHide={handleClose}>
                    <Modal.Header>
                        <Modal.Title>اکشن حذف شود ؟ </Modal.Title>
                    </Modal.Header>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            انصراف
                        </Button>
                        <Button variant="primary" onClick={deleteThisAction}>
                            تایید
                        </Button>
                    </Modal.Footer>
                </Modal>
            : ''}
    </div>
  )
};

export default ExpoManage;
